// extracted by mini-css-extract-plugin
export default {"root":"TaskList_root__NYlLO","gridPanel":"TaskList_gridPanel__vsckp","rowClass":"TaskList_rowClass__0Ei3Q"};